import React, { Component } from "react";
import PageHeaderWrapper from "../../../../components/PageHeaderWrapper";
import { TableComp } from "sz-react-utils";
import moment from "moment/moment";
import ListFollowUps from "../../../../components/_utils/listFollowUp";
import {
  Popconfirm,
  Avatar,
  Button,
  Card,
  Col,
  DatePicker,
  Icon,
  Input,
  Row,
  Select,
  Tooltip,
  Switch,
  Checkbox,
  notification,
} from "antd/lib/index";
import Request from "../../../../request";
import LatestFollowUp from "../../../../components/_utils/latestFollowup";
import { connect } from "react-redux";
import styles from "./styles.less";
import common from "../../../common.less";
import Settings from "../../../../components/_utils/settings";
import rightAuth from "../../../../components/_utils/userRights";
import _ from "lodash";
import lodash from "lodash";
import SMS from "../../../../components/communication/sms";
import WhatsAPPSMS from "../../../../components/communication/WhatsAppSms";
import EmailDrawer from "../../../../components/communication/emailDrawer";
import { RightsWrapper } from "../../../../components/_utils/utils";
import ClickToCallDrawer from "../../../Student/inquiry/all/clickToCall";
const showDroppedLeads = rightAuth.checkUserRights('showDropLead')
const showDropLead = rightAuth.checkUserRights('dropLead')
let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';
let studentObj = {};
let userCheckBox = {};
let counsellingData = {};
const { Search } = Input
const Option = Select.Option;
const statusList = [
  { level: "Application", status: "Pending" },
  { level: "Application", status: "Received" },
  { level: "Application", status: "Being Reviewed" },
  { level: "Application", status: "Pending Documents" },
  { level: "Application", status: "Processed" },
  { level: "Application", status: "Received by University" },
  { level: "Application", status: "Offer Expected" },
  { level: "Application", status: "Admission Rejected" },
  { level: "Offer", status: "Offer Pending" },
  { level: "Offer", status: "Interview Reqd" },
  { level: "Offer", status: "Offer Rejected" },
  { level: "Offer", status: "Addl Docs Reqd" },
  { level: "Offer", status: "Conditional Offer Received" },
  { level: "Offer", status: "Unconditional Offer Received" },
];

const { RangePicker } = DatePicker;

class CollapseViewCourse extends Component {
  state = {
    cp: false,
  };

  render() {
    const { cp } = this.state;
    const clondData = this.props.children;
    return (
      <React.Fragment>
        <div>
          <div
            className={
              cp ? styles.questioncollapse : styles.questioncollapsenot
            }
          >
            {clondData &&
              clondData.course
                .slice(0, cp ? clondData.course.length : 1)
                .map((item) => {
                  return (
                    <ul className={styles.ul}>
                      <li>
                        <b>{item.courseName}</b>
                      </li>
                      <li>{item.universityInstitutionName}</li>
                      <li>
                        <small>
                          {" "}
                          {item.univData &&
                            item.univData.universityCityId &&
                            `${item.univData.universityCityId.cityName} ,`}
                          {item.univData &&
                            item.univData.universityStateId &&
                            `${item.univData.universityStateId.stateName} ,`}
                          {item.univData &&
                            item.univData.universityCountryId &&
                            `${item.univData.universityCountryId.countryName}`}
                        </small>
                      </li>
                    </ul>
                  );
                })}
          </div>
          {clondData && clondData.course && clondData.course.length > 1 ? (
            <button
              style={{ color: "red" }}
              onClick={() => {
                this.setState({
                  cp: !cp,
                });
              }}
            >
              {cp ? <p>View Less - </p> : <p>View More + </p>}
            </button>
          ) : null}
        </div>
      </React.Fragment>
    );
  }
}

class CollapseViewStage extends Component {
  state = {
    cp: false,
  };

  render() {
    const { cp } = this.state;
    const clondData = this.props.children;
    return (
      <React.Fragment>
        <div>
          {clondData &&
            clondData.course
              .slice(0, cp ? clondData.course.length : 1)
              .map((item, index) => {
                const { stage2 } = item;
                let processedApplication = [];
                let lastApplicationStatus = _.last(item.applicationStatus);
                if (
                  item &&
                  Array.isArray(item.applicationStatus) &&
                  item.applicationStatus.length > 0
                ) {
                  processedApplication = item.applicationStatus.filter(
                    (x) => x.status === "Processed"
                  );
                }
                return (
                  <div className={styles.border1}>
                    <div style={{ width: "60%" }}>
                      {processedApplication && processedApplication.length ? (
                        <div style={{ margin: "10px" }}>
                          <b>Processed Date: </b>
                          <span>
                            {" "}
                            {processedApplication &&
                              moment(processedApplication[0].date).format(
                                "DD-MMM-YYYY"
                              )}
                          </span>
                        </div>
                      ) : (
                        ""
                      )}

                      {item &&
                        item.applicationStatus &&
                        item.applicationStatus.length ? (
                        <div style={{ margin: "10px" }}>
                          <b>Application: </b>
                          <span style={{ backgroundColor: "#259672e6" }}>
                            {" "}
                            <b>
                              {lastApplicationStatus &&
                                lastApplicationStatus.status}
                            </b>
                          </span>
                          &nbsp;&nbsp;
                          <span>
                            {" "}
                            {lastApplicationStatus &&
                              moment(lastApplicationStatus.date).format(
                                "DD-MMM-YYYY"
                              )}
                          </span>
                        </div>
                      ) : (
                        <div style={{ margin: "10px" }}>
                          <b>Application: </b> {item && item.stage1 && item.stage1.status}
                        </div>
                      )}

                      {item && item.stage1 && item.stage1.status === "Admission Rejected" ? null :
                        <div style={{ margin: "10px" }}>
                          <b>Offer Status: </b>
                          <span style={{ backgroundColor: "#eb65e7" }}>
                            <b> {stage2 && stage2.offerStatus}</b>
                          </span>
                          &nbsp;&nbsp;
                          <span>
                            {stage2 && stage2.offerStatusDate
                              ? moment(stage2.offerStatusDate).format(
                                "DD-MMM -YYYY"
                              )
                              : moment().format("DD-MMM -YYYY")}
                          </span>
                        </div>
                      }
                      {item.processedDate ? (
                        <div style={{ margin: "10px" }}>
                          {stage2 && (stage2.offerStatus ===
                            "Conditional Offer Received" ||
                            stage2.offerStatus ===
                            "Unconditional Offer Received") ? (
                            <div>
                              <b>Fee Due Date: </b>
                              {moment(stage2 && stage2.feeDueDate).format("DD-MMM -YYYY")}
                            </div>
                          ) : (
                            <div>
                              <b>Offer Expected Date: </b>
                              {moment(stage2 && stage2.offerExpDate).format(
                                "DD-MMM -YYYY"
                              )}
                            </div>
                          )}
                        </div>
                      ) : null}
                    </div>

                    {/* <div style={{ width: '40%' }}>
                {stage1 || stage2 ?
                  <ul className={styles.one1}>
                    {stage2 && stage2.mailStatusDate ? <li>
                      {
                        item.stage2 ? <div>
                          <b> Stage 2</b><br />
                          <b>Offer expected :</b>
                          <span> {stage2 && stage2.offerExpDate ? moment(stage2.offerExpDate).format('DD-MMM-YYYY') : null}</span>
                          <div>{stage2.mailStatus}</div>

                          {stage2.offerStatus ? <div>
                            ---------------------
                            <div>
                              <b>Offer Detail:</b>
                              <div>
                                {stage2.offerStatus} : {stage2 && stage2.offerStatusDate ? moment(stage2.offerStatusDate).format('DD-MMM-YYYY') : null}
                              </div>

                              <div>---------------------</div>
                              <div><b>Fee Due Date : </b>
                                {stage2 && stage2.feeDueDate ? moment(stage2.feeDueDate).format('DD-MMM-YYYY') : null}
                              </div>
                            </div>

                            <div>---------------------</div>
                            <div><b>Fee Due Date : </b>
                            {stage2 && stage2.feeDueDate ? moment(stage2.feeDueDate).format('DD-MMM-YYYY') : null}
                            </div>
                          </div> : null}
                        </div> : null
                      }
                    </li> : <li>
                        {
                          item.stage1 ? <div>
                            <b> Stage 1</b><br />
                            <b>Application Detail:</b>
                            <div>{stage1.status}</div>
                          </div> : null
                        }
                      </li>}


                  </ul> : null
                }

              </div>
              <div style={{ width: '38%', borderLeft: '1px solid #cccccc', }}>
                {item && item.applicationStatus && item.applicationStatus.length ?

                  <ul>
                    {item.applicationStatus.map((item1, key) => {

                      if (item1.status == 'Offer Expected on') {
                        item1.status = 'as on'
                      }
                      return <li key={key}>
                        <div>
                          <Icon
                            type="right" /> Status {item1.status} : <b>{moment(item1.date).format('DD-MMM-YYYY')}</b>
                        </div>
                      </li>
                    })}
                  </ul>

                  : null
                }
              </div>*/}

                    <div
                      style={{
                        width: "40%",
                        borderLeft: "1px solid #cccccc",
                        paddingLeft: "10px",
                      }}
                    >
                      <div>
                        <b>Course/University</b>
                        <ul>
                          <li>
                            <b>
                              {item.courseName}
                              {item.campusName && `(${item.campusName})`}
                            </b>
                          </li>
                          <li>{item.universityInstitutionName}</li>
                          <li>
                            <small>
                              {" "}
                              {item.univData &&
                                item.univData.universityCityId &&
                                `${item.univData.universityCityId.cityName} ,`}
                              {item.univData &&
                                item.univData.universityStateId &&
                                `${item.univData.universityStateId.stateName
                                } ,`}
                              {item.univData &&
                                item.univData.universityCountryId &&
                                `${item.univData.universityCountryId.countryName
                                }`}
                            </small>
                          </li>
                          <li>
                            {item.channelPartnerName !== undefined &&
                              item.channelPartnerName ? (
                              <div>
                                <b>Channel Partner:</b>{" "}
                                {item.channelPartnerName}{" "}
                              </div>
                            ) : null}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                );
              })}
          {clondData && clondData.course && clondData.course.length > 1 ? (
            <button
              style={{ color: "red" }}
              onClick={() => {
                this.setState({
                  cp: !cp,
                });
              }}
            >
              {cp ? <p>View Less - </p> : <p>View More + </p>}
            </button>
          ) : null}
        </div>
      </React.Fragment>
    );
  }
}

class ApplicationStatusView extends Component {
  state = {
    cp: false,
  };

  render() {
    const { cp } = this.state;
    const clondData = this.props.children;
    return (
      <React.Fragment>
        <div>
          {clondData &&
            clondData.course &&
            clondData.course
              .slice(0, cp ? clondData.course.length : 1)
              .map((item, index) => {
                return (
                  <React.Fragment>
                    {item &&
                      item.applicationStatus &&
                      item.applicationStatus.length ? (
                      <ul className={styles.ul}>
                        {item.applicationStatus.map((item1, key) => {
                          return (
                            <li key={key}>
                              <div>
                                <Icon type="right" />
                                {item1.status} :{" "}
                                <b>
                                  {moment(item1.date).format("DD-MMM-YYYY")}
                                </b>
                              </div>
                            </li>
                          );
                        })}
                      </ul>
                    ) : null}
                  </React.Fragment>
                );
              })}
          {clondData && clondData.course && clondData.course.length > 1 ? (
            <button
              style={{ color: "red" }}
              onClick={() => {
                this.setState({
                  cp: !cp,
                });
              }}
            >
              {cp ? <p>View Less - </p> : <p>View More + </p>}
            </button>
          ) : null}
        </div>
      </React.Fragment>
    );
  }
}

class ApplicationDesk extends Component {
  state = {
    search_keyword: '',
    count: 0,
    followDuesCount: 0,
    showFollowUp: false,
    studentId: null,
    studentSearchId: "",
    branchId: "",
    counsellorId: "",
    counsellors: [],
    ratingArr: ["Fit2Apply", "Potential", "Luke Warm", "Cold", "Dead"],
    allBranches: [],
    allCounsellor: [],
    allUsers: [],
    deskColor: null,
    showCallDrawer: false,
    recordForCall: {},
    exportParams: {},
    time: {
      key: "applicationsDesk.course.state2.offerExpDate",
      from: null,
      to: null,
    },
    courseName: null,
    universityInstitutionName: null,
    aggrementSigned: [
      { label: "Yes", value: true },
      { label: "No", value: false },
    ],
    overdueByOptions: [
      { value: true, label: "Yes" },
      { value: false, label: "No" },
    ],
    isFollowUpOverdue: false,
    showSMS: false,
    showWhatsAppSms: false,
    showEmail: false,
    userCheckBox: {},
    showDropped: false
  };

  constructor(props) {
    super(props);
    this.table = React.createRef();
    this.followUpsCallback = this.followUpsCallback.bind(this);
    Request.getCounsellorsUsers()
      .then((resp) => {
        if (resp) {
          let temp = [{ display: "---Show All---", id: "" }];
          resp.data = resp.data.reduce((el, vv) => {
            vv.display = vv.name;
            vv.id = vv._id;
            temp.push(vv);
            return temp;
          }, []);
          this.setState({ counsellors: resp.data });
        }
      })
      .catch((err) => { });
  }

  closeFollowUp = () => {
    this.setState({ showFollowUp: false });
  };
  openFollowUps = (record) => {
    studentObj = {
      arr: record.followUp,
      name: record.studentName,
      rating: record.counsellingDesk.rating,
      subRating: record.counsellingDesk.subRating,
      _id: record._id,
    };
    this.setState({ showFollowUp: true });
  };
  renderStatus = (val) => {
    if (val === "Super Hot") {
      return <div className={styles.SuperHot}>{val.toUpperCase()}</div>;
    }
    if (val === "Fit2Apply") {
      return <div className={styles.Fit2Apply}>{val.toUpperCase()}</div>;
    }

    if (val === "Luke Warm") {
      return <div className={styles.LukeWarm}>{val.toUpperCase()}</div>;
    }

    if (val === "Potential") {
      return <div className={styles.Potential}>{val.toUpperCase()}</div>;
    }

    if (val === "Dead") {
      return <div className={styles.dead}>{val.toUpperCase()}</div>;
    }

    if (val === "Cold") {
      return <div className={styles.Cold}>{val.toUpperCase()}</div>;
    }
  };

  reload = () => {
    this.table.current.reload();
  };

  closeCallDrawer = () => {
    this.setState({ showCallDrawer: false, recordForCall: {} }, () => {
      this.reload();
    })
  }

  loadUserBranchWise = () => {
    return new Promise(async (resolve) => {
      let { data } = await Request.loadUserBranchWise({
        results: 10000,
        isAdmission: true,
      });
      this.setState({
        allUsers: data,
        loading: false,
      });
    });
  };

  chooseRangerPicker = (date, dateString) => {
    this.setState(
      {
        time: {
          key: "applicationsDesk.course.stage2.offerExpDate",
          from: moment(date[0]).startOf('day'),
          to: moment(date[1]).endOf('day'),
        },
      },
      () => {
        if (date[0] === undefined) {
          this.reload();
        }
      }
    );
  };
  chooseRangerPickerApplicationDesk = (date, dateString) => {
    this.setState(
      {
        time: {
          key: "moveDeskDate.moveToApplicationDesk",
          from: date[0],
          to: date[1],
        },
      },
      () => {
        if (date[0] === undefined) {
          this.reload();
        }
      }
    );
  };
  dropLeads = async () => {
    let userArr = lodash.filter(this.state.userCheckBox, (item) => {
      return item.isChecked
    })
    if (userArr && userArr.length) {
      counsellingData = {
        usersData: userArr
      }
      let response = await Request.dropInquiry(counsellingData)
      if (response.success) {
        notification.success({
          message: response.message
        })
      } else {
        notification.error({
          message: 'Something Went Wrong'
        })
      }
      this.table.current.reload()
    } else {
      notification.error({
        message: 'Please select atleast 1 user.'
      })
    }
  }

  toggleDroppedLeads = () => {
    let showDropped = this.state.showDropped;
    showDropped = !showDropped
    this.setState({ showDropped }, () => {
      this.table.current.reload()
    })
  }

  onOk = (value) => {
    this.reload();
  };

  changeAggreementSignedStatus = async ({ checked, _id }) => {
    await Request.changeAggreementSignedStatus({
      _id,
      aggrementSigned: checked,
    });
    this.table.current.reload();
  };

  apiRequest = (params, columns) => {
    return new Promise(async (resolve) => {
      // params.count = 200


      if (!params.sortField) {
        params.sortField = "moveDeskDate.moveToApplicationDesk";
        params.sortOrder = "descend";
      }
      if (this.state.counsellorId) {
        params.counsellorId = this.state.counsellorId;
        params.page = 1;
      }
      if (this.state.studentSearchId) {
        params.studentSearchId = this.state.studentSearchId;
        params.page = 1;
      } else {
        params.studentSearchId = "";
      }
      if (this.state.search_keyword && this.state.search_keyword !== "") {
        params.keyword = this.state.search_keyword
      }
      if (this.state.branchId) {
        params.studentBranchId = this.state.branchId;
        params.page = 1;
      }
      if (this.state.status) {
        const { status, countryId, mailStatus } = this.state;
        if (typeof status === "string") {
          params.status = [`Application - ${this.state.status}`];
        } else {
          params.status = status.map((x) => `Application - ${x}`);
        }

        if (status === "Offer Pending") {
          params["applicationsDesk.course.stage2.mailStatus"] = mailStatus;
        }
        if (status === "Offer Pending" && countryId && mailStatus) {
          params.countryId = countryId;
          params["applicationsDesk.course.stage2.mailStatus"] = mailStatus;
        }
      }

      if (this.state.courseName) {
        params["applicationsDesk.course.courseName"] = this.state.courseName;
      }
      if (this.state.universityInstitutionName) {
        params[
          "applicationsDesk.course.universityInstitutionName"
        ] = this.state.universityInstitutionName;
      }
      params.dropped = this.state.showDropped
      if (params.dateOfBirth && params.dateOfBirth.length > 0) {
        var splitDate = params.dateOfBirth[0].split("-");
        const monthNames = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];
        var monthName = monthNames[splitDate[1] - 1];

        params.dateOfBirth =
          splitDate[0] + "-" + monthName + "-" + splitDate[2];

        const stringToDate = new Date(params.dateOfBirth);
        params.dateOfBirth = {
          $gte: moment(params.dateOfBirth, dateFormat).startOf('day'),
          $lt: moment(params.dateOfBirth, dateFormat).endOf('day'),
        };
      } else {
        delete params.dateOfBirth;
      }

      if (this.state.isFollowUpOverdue) {
        params.isFollowUpOverdue = this.state.isFollowUpOverdue;
      }

      params.atLevel = ["Application Desk"];
      let data = await Request.loadCounselling({
        ...params,
        dateFilter: this.state.time,
        regExFilters: [
          "studentName",
          "location",
          "email",
          "mobile",
          "updatedByUser.name",
          "createdByUser.name",
          "applicationsDesk.course.courseName",
          "applicationsDesk.course.universityInstitutionName",
        ],
      });
      lodash.each(data.data, (item) => {
        if (!userCheckBox[item._id]) {
          userCheckBox[item._id] = {
            _id: item._id,
            emailId: item.emailId,
            mobile: item.mobile,
            studentName: item.studentName,
            isChecked: false,
          };
        }
      });

      delete data.error;
      delete data.type;
      this.setState({
        count: data.total,
        followDuesCount: data.followUpsDuesCount,
        allBranches: data.allBranches,
        userCheckBox: userCheckBox,
        exportParams: params
      });
      resolve(data);
    });
  };

  exportExcel = async () => {
    const { exportParams, count } = this.state
    exportParams.results = count
    exportParams.count = count
    // let x = await Request.exportOperationDeskToExcel({...exportParams});
    let x = await Request.exportCounsellingDeskToExcel({ ...exportParams });
    // let x = await Request.exportUsersToExcel({
    //      regExFilters: ['name'
    //     ]
    // })
    if (!x.error) {
      window.open(x.url)
    }
  }

  followUpExtendedDate = (followUp) => {
    if (followUp && followUp.followUpDate) {
      return moment(
        moment(new Date()).format("YYYY-MM-DD[T00:00:00.000Z]")
      ).isAfter(followUp.followUpDate);
    }
  };

  componentWillMount() {
    let searchParams = new URLSearchParams(this.props.search);

    let status = searchParams.get("status");
    let countryId = searchParams.get("countryId");
    let mailStatus = searchParams.get("mailStatus");
    let applicationStageWiseCount = searchParams.get(
      "applicationStageWiseCount"
    );

    let dateFilterByWeekOrMonth = searchParams.get("dateFilterByWeekOrMonth");
    let newApplication = searchParams.get("dateFilter");

    let counsellorId = searchParams.get("counsellorId");
    let branchId = searchParams.get("studentBranchId");

    let currentDate = moment().endOf("day");
    let oldDate = moment()
      .subtract(3, "days")
      .startOf("day");

    if (
      status === "Offer Pending" &&
      countryId &&
      mailStatus === "Application Processed"
    ) {
      this.setState({ status: status, countryId, mailStatus });
    }
    if (status === "Offer Pending" && mailStatus === "Application Processed") {
      this.setState({ status: status, mailStatus });
    }

    if (applicationStageWiseCount) {
      if (
        applicationStageWiseCount === "Offer Pending" ||
        applicationStageWiseCount === "Conditional Offer Received" ||
        applicationStageWiseCount === "Unconditional Offer Received" ||
        applicationStageWiseCount === "Interview Reqd" ||
        applicationStageWiseCount === "Addl Docs Reqd" ||
        applicationStageWiseCount === "Offer Rejected"
      ) {
        this.setState({
          status: applicationStageWiseCount,
          mailStatus: "Application Processed",
        });
      } else {
        this.setState({ status: applicationStageWiseCount });
      }
    }

    if (branchId || counsellorId) {
      this.setState({ branchId, counsellorId });
    }

    if (status === "Pending") {
      this.setState(
        {
          time: {
            key: "moveDeskDate.moveToApplicationDesk",
            from: oldDate,
            to: currentDate,
          },
          status: status,
        },
        () => {
          console.log("adsffs", this.state.time, this.state.status);
        }
      );
    }

    if (status === "Processed") {
      this.setState(
        {
          time: {
            key: "applicationsDesk.course.processedDate",
            from: oldDate,
            to: currentDate,
          },
          status: status,
        },
        () => {
          console.log("adsffs", this.state.time, this.state.status);
        }
      );
    }

    if (newApplication) {
      if (status === "Pending") {
        this.setState(
          {
            time: {
              key: "moveDeskDate.moveToApplicationDesk",
              from: moment(newApplication, "DD-MM-YYYY")
                .startOf("day")
                .toDate(),
              to: moment(newApplication, "DD-MM-YYYY")
                .endOf("day")
                .toDate(),
            },
            status: status,
          },
          () => {
            console.log("adsffs", this.state.time, this.state.status);
          }
        );
      }
      if (
        status == ["Conditional Offer Received", "Unconditional Offer Received"]
      ) {
        this.setState(
          {
            time: {
              key: "applicationsDesk.course.stage2.offerStatusDate",
              from: moment(newApplication, "DD-MM-YYYY")
                .startOf("day")
                .toDate(),
              to: moment(newApplication, "DD-MM-YYYY")
                .endOf("day")
                .toDate(),
            },
            status: status,
          },
          () => {
            console.log("adsffs", this.state.time, this.state.status);
          }
        );
      }
      if (status === "Processed") {
        this.setState(
          {
            time: {
              key: "applicationsDesk.course.processedDate",
              from: moment(newApplication, "DD-MM-YYYY")
                .startOf("day")
                .toDate(),
              to: moment(newApplication, "DD-MM-YYYY")
                .endOf("day")
                .toDate(),
            },
            status: status,
          },
          () => {
            console.log("adsffs", this.state.time, this.state.status);
          }
        );
      }
    }

    if (
      status == ["Conditional Offer Received", "Unconditional Offer Received"]
    ) {
      this.setState({ status: status.split(",") });
    }

    if (dateFilterByWeekOrMonth) {
      let weakStartDate = moment()
        .startOf(`${dateFilterByWeekOrMonth}`)
        .format();
      let weakEndDate = moment()
        .endOf(`${dateFilterByWeekOrMonth}`)
        .format();
      this.setState(
        {
          time: {
            key: "moveDeskDate.moveToApplicationDesk",
            from: weakStartDate,
            to: weakEndDate,
          },
        },
        () => {
          console.log("adsffs", this.state.time);
        }
      );
    }

    this.setState({ deskColor: Settings.deskColor("Application Desk") });
  }

  async componentDidMount() {
    window.onkeydown = function (e) {
      var ck = e.keyCode ? e.keyCode : e.which;
      if (e.ctrlKey && ck == 70) {
        if (document.querySelector('#search-student-input')) {
          document.querySelector('#search-student-input').focus();
        }
        return false;
      } else if (ck == 27) {
        if (document.querySelector('#search-student-input')) {
          document.querySelector('#search-student-input').focus();
        }
        return false;
      }
    }
    let { data } = await Request.loadCounsellor({
      results: 10000,
      atLevel: ["Application Desk"],
    });
    this.setState({
      allCounsellor: data,
      loading: false,
    });

    this.loadUserBranchWise();
  }

  changeSearchValue = (value) => {
    this.setState({ search_keyword: value }, () => {
      this.table.current.reload()
    })
  }

  followUpsCallback(isFollowUpOverdue) {
    this.setState(
      {
        isFollowUpOverdue: isFollowUpOverdue,
      },
      () => {
        this.table.current.reload();
      }
    );
  }

  showSMS = () => {
    let userArr = lodash.filter(this.state.userCheckBox, (item) => {
      return item.isChecked;
    });
    if (userArr && userArr.length) {
      counsellingData = {
        usersData: userArr,
      };
      this.setState({ showSMS: true });
    } else {
      notification.error({
        message: "Please select atleast 1 user.",
      });
    }
  };
  closeSMS = () => {
    this.setState({ showSMS: false });
  };
  showWhatsAppSms = () => {
    let userArr = lodash.filter(this.state.userCheckBox, (item) => {
      return item.isChecked === true ? item : false;
    });

    if (userArr && userArr.length) {
      counsellingData = {
        usersData: userArr,
      };
      this.setState({ showWhatsAppSms: true });
    } else {
      notification.error({
        message: "Please select atleast 1 user.",
      });
    }
  };
  closeWhatsSMS = () => {
    this.setState({ showWhatsAppSms: false });
  };
  closeEmail = () => {
    this.setState({ showEmail: false });
  };
  showEmail = () => {
    let userArr = lodash.filter(this.state.userCheckBox, (item) => {
      return item.isChecked;
    });
    if (userArr && userArr.length) {
      counsellingData = {
        usersData: userArr,
      };
      this.setState({ showEmail: true });
    } else {
      notification.error({
        message: "Please select atleast 1 user.",
      });
    }
  };
  selectUser = (item, studentId) => {
    let cloneUserCheckBox = lodash.clone(this.state.userCheckBox);
    if (cloneUserCheckBox[studentId] === undefined) {
      cloneUserCheckBox[studentId] = [];
    }
    cloneUserCheckBox[studentId].isChecked = !cloneUserCheckBox[studentId]
      .isChecked;
    this.setState({ userCheckBox: cloneUserCheckBox });
  };
  selectAllUserFxn = () => {
    let cloneUserCheckBox = lodash.clone(this.state.userCheckBox);
    lodash.each(cloneUserCheckBox, (item) => {
      item.isChecked = true;
    });
    this.setState({ userCheckBox: cloneUserCheckBox });
  };
  unselectAllUserFxn = () => {
    let cloneUserCheckBox = lodash.clone(this.state.userCheckBox);
    lodash.each(cloneUserCheckBox, (item) => {
      item.isChecked = false;
    });
    this.setState({ userCheckBox: cloneUserCheckBox });
  };

  render() {
    const {
      allBranches = [],
      allCounsellor = [],
      allUsers = [],
      deskColor,
      courseName,
      universityInstitutionName,
      aggrementSigned,
      counsellors,
      overdueByOptions,
    } = this.state;

    const columns = [
      {
        title: "Action",
        key: "operation",
        dataindex: "operation",
        width: 70,
        fixed: true,
        render: (text, record) => (
          <div className={styles.btnWrapper}>
            <Tooltip title="Select">
              <span className={styles.userSelectCheckbox}>
                <Checkbox
                  checked={
                    userCheckBox[record._id]
                      ? userCheckBox[record._id].isChecked
                      : false
                  }
                  onChange={(y) => {
                    this.selectUser(y, record._id);
                  }}
                />
              </span>
            </Tooltip>
            &nbsp;
            <Tooltip title="Notes">
              <Button
                shape="circle"
                size={"small"}
                onClick={() => this.openFollowUps(record)}
                icon="calendar"
              />
            </Tooltip>
            <Tooltip title="Click To Edit Details">
              <Button
                shape="circle"
                size={"small"}
                href={`/desk/allApplication-desk/update?id=${record._id}`}
                icon="edit"
              />
            </Tooltip>
          </div>
        ),
      },

      {
        title: "VID",
        key: "id",
        dataIndex: "id",
        sorter: true,
        fixed: true,
        width: 120,
        searchTextName: "id",
        filterRegex: true,
      },
      {
        title: "Student Name",
        key: "studentName",
        dataIndex: "studentName",
        sorter: true,
        fixed: true,
        width: 160,
        searchTextName: "studentName",
        filterRegex: true,
        render: (text, record) => (
          <React.Fragment>
            <div
              className={
                this.followUpExtendedDate(
                  record.followUp ? record.followUp : ""
                )
                  ? styles.followUpExtendedDate
                  : ""
              }
            >
              <Tooltip title="Click To Edit Details">
                <a
                  className={styles.btn}
                  target={"_blank"}
                  href={`/inquiry/studentProfileDetails?id=${record._id}`}
                >
                  {text}
                </a>
              </Tooltip>
            </div>
            {record.moveType === "Application Desk - partial" ? (
              <small
                style={{
                  background: "red",
                  fontSize: "12px",
                  color: "white",
                  padding: "5px",
                  marginTop: "10px",
                  display: "block",
                }}
              >
                Application moved to Visa desk partially
              </small>
            ) : null}
          </React.Fragment>
        ),
      },
      {
        title: "Date Of Birth",
        width: 110,
        key: "dateOfBirth",
        dataIndex: "dateOfBirth",
        searchTextName: `${dateFormat}`,
        render: (val, record) => {
          return (
            <div>
              {record.dateOfBirth
                ? moment(record.dateOfBirth).format(dateFormat)
                : ""}
            </div>
          );
        },
      },
      {
        title: 'Passport No',
        key: 'passportNo',
        searchTextName: 'passportNo',
        filterRegex: true,
        width: 100,
        dataIndex: 'visaDesk.passportNo'
      },
      {
        title: "Preference",
        width: 150,
        key: "preference",
        searchTextName: "preference",
        render: (val, row) => {
          return row.totalPreference ? (
            <ul className={common.ul}>
              {row.totalPreference.map((val, inde) => {
                return <li key={inde}>{val.country}</li>;
              })}
            </ul>
          ) : null;
        },
      },
      {
        title: 'Course/University',
        key: 'counsellingDesk.course',
        width: 450,
        dataIndex: 'course',
        render: (text, record) => {
          return (
            <div>
              <div>
                {record.counsellingDesk && record.counsellingDesk.course.map((item) => {
                  return <ul className={styles.ul}>
                    <li><b>{item.courseName}</b></li>
                    <li>{item.universityInstitutionName}</li>
                    <li>
                      <small>   {item.univData && item.univData.universityCityId && `${item.univData.universityCityId.cityName} ,`}
                        {item.univData && item.univData.universityStateId && `${item.univData.universityStateId.stateName} ,`}
                        {item.univData && item.univData.universityCountryId && `${item.univData.universityCountryId.countryName}`}</small>
                    </li>

                  </ul>

                })}
              </div>
            </div>
          )
        }
      },
      {
        title: "Follow Up",
        key: "followUp",
        width: 180,
        dataIndex: "followUp",
        searchTextName: "followUp",
        render: (text, record) => {
          return <LatestFollowUp info={text} />;
        },
      },
      {
        title: 'Last FollowUp By',
        key: 'followUp.assignByName',
        searchTextName: 'Last FollowUp By',
        filterRegex: true,
        width: 160,
      },
      {
        title: "Admission Status",
        key: "status",
        width: 500,
        filters: statusList.map((x) => ({
          value: `${x.level} - ${x.status}`,
          text: `${x.level} - ${x.status}`,
        })),
        filterMultiple: false,
        dataIndex: "stage",
        render: (text, record) => {
          return (
            <div>
              <CollapseViewStage>{record.applicationsDesk}</CollapseViewStage>
            </div>
          );
        },
      },
      {
        title: "Overdue By",
        key: "overdueBy",
        width: 180,
        dataIndex: "overdueBy",
        filterMultiple: false,
        render: (val, record) => {
          return (
            <div
              className="post__content"
              dangerouslySetInnerHTML={{ __html: val }}
            />
          );
        },
        filters:
          overdueByOptions &&
          overdueByOptions.map((x) => ({
            value: x.value,
            text: x.label,
          })),
      },
      {
        title: "Registration Details ",
        width: 150,
        key: "registrationDesk",
        dataIndex: "registrationDesk",
        render: (val, record) => {
          if (val) {
            const {
              mode,
              total,
              paid,
              balance,
              receipt,
              dateOfReciept,
              documentName,
              channelPartnerName,
            } = val;

            if (mode === "Fee") {
              return (
                <ul className={common.followul}>
                  <li>
                    <b>{mode}</b>
                  </li>
                  <li>Total :{total}</li>
                  <li>Paid :{paid}</li>
                  <li>Balance :{balance}</li>
                  <li>Receipt :{receipt}</li>
                  <li>DOR : {moment(dateOfReciept).format(dateFormat)}</li>
                </ul>
              );
            }
            if (mode === "Document") {
              return (
                <ul className={common.followul}>
                  <li>
                    <b>Document</b>
                  </li>
                  <li>{documentName}</li>
                </ul>
              );
            }
            if (mode === "Partner") {
              return (
                <ul className={common.followul}>
                  <li>
                    <b>Partner</b>
                  </li>
                  <li>{channelPartnerName}</li>
                </ul>
              );
            }
            return null;
          } else {
            return null;
          }
        },
      },
      {
        title: "MOB/WAP/Mail",
        key: "mobwap",
        width: 180,
        dataIndex: "mobwap",
        searchTextName: "MOB/WAP/Mail",
        render: (val, record) => {
          return (
            <div>
              <div>
                {" "}
                {record.mobile &&
                  record.mobile.length >= 10 &&
                  rightAuth.checkRights("ShowClickToCall.view") ? (
                  <Tooltip title="Start Call">
                    <Button
                      className="ant-btn ant-btn-primary"
                      onClick={() => {
                        this.setState({ showCallDrawer: true, recordForCall: record })
                      }}
                    // onClick={(e) => {

                    //   dispatch(showLoader());
                    //   Request.callInitiate({
                    //     mobile: record.mobile,
                    //   }).then(({ data, error, message }) => {
                    //     dispatch(hideLoader());
                    //     if (!error) {
                    //       notification.success({
                    //         message: message,
                    //       });
                    //     } else {
                    //       notification.error({
                    //         message: message,
                    //       });
                    //     }
                    //   });
                    // }}
                    >
                      Click To Call
                    </Button>
                  </Tooltip>
                ) : (
                  record.mobile
                )}
              </div>
              {/* <div>
                <span>{record.mobile}</span>
              </div> */}
              <div>
                {record.watsupp && record.watsupp.length === 10 ? (
                  <Tooltip title="Share on Whatsapp">
                    <a
                      target={"_blank"}
                      style={{ textDecoration: "underline" }}
                      href={`http://api.whatsapp.com/send?phone=91${record.watsupp
                        }&text=&source=&data=`}
                    >
                      {record.watsupp}
                    </a>
                  </Tooltip>
                ) : (
                  record.watsupp
                )}
              </div>
              <div>
                <span>{record.emailId}</span>
              </div>
            </div>
          );
        },
      },

      // {
      //   title: "Photo",
      //   key: "profilePic",
      //   width: 60,
      //   dataIndex: "profilePic",
      //   render: (val) => {
      //     return <Avatar src={val} />;
      //   },
      // },

      // {
      //   title: "Agreement Signed",
      //   key: "aggreementSigned",
      //   width: 130,
      //   dataIndex: "aggreementSigned",
      //   filters:
      //     aggrementSigned &&
      //     aggrementSigned.map((x) => ({ value: x.value, text: x.label })),
      //   filterMultiple: false,
      //   render: (val, record) => {
      //     return (
      //       <div className={styles.wrap}>
      //         <Switch
      //           checked={record.applicationsDesk.aggrementSigned}
      //           onChange={(checked) => {
      //             this.changeAggreementSignedStatus({
      //               checked,
      //               _id: record._id,
      //             });
      //           }}
      //         />
      //       </div>
      //     );
      //   },
      // },








      {
        title: "Source",
        width: 100,
        key: "location",
        dataIndex: "location",
        searchTextName: "location",
      },
      /* {
               title: 'Rating',
               key: 'rating',
               width: 180,

               dataIndex: 'counsellingDesk.rating',
               // filters: ratingArr && ratingArr.map(x => ({value: x, text: x})),
               render: (val, record) => {
                 return this.renderStatus(val)

               }
             },*/
      {
        title: "Test Scores",
        key: "ieltsOverallScore",
        dataIndex: "ieltsOverallScore",
        searchTextName: "ieltsOverallScore",
        width: 180,
        render: (text, record) => {
          return (
            <div style={{ fontSize: "12px" }}>
              <div style={{ paddingBottom: "4px" }}>
                {" "}
                {record.testType && text
                  ? `${record.testType} OverAll : ${text}`
                  : null}
              </div>
              <div style={{ paddingBottom: "4px" }}>
                {record && record.profile && record.profile.reading
                  ? `Reading : ${record.profile.reading}`
                  : null}{" "}
                {record && record.profile && record.profile.writing
                  ? `Writing : ${record.profile.writing}`
                  : null}{" "}
              </div>
              <div>
                {record && record.profile && record.profile.listening
                  ? `Listening : ${record.profile.listening}`
                  : null}{" "}
                {record && record.profile && record.profile.speaking
                  ? `Speaking : ${record.profile.speaking}`
                  : null}
              </div>
            </div>
          );
        },
      },

      {
        title: "Counsellor",
        width: 150,
        key: "counsellorId",
        filters: allCounsellor.map((x) => ({ value: x._id, text: x.name })),
        render: (text, record) => {
          return (
            <div>{record.counsellorId ? record.counsellorId.name : ""}</div>
          );
        },
      },
      {
        title: "Processed By",
        width: 150,
        filters: Array.isArray(allUsers)
          ? allUsers.map(x => ({ value: x._id, text: x.name }))
          : [],
        key: "processedBy",
        render: (text, record) => {

          if (
            !record ||
            !record.applicationsDesk ||
            !Array.isArray(record.applicationsDesk.course) ||
            record.applicationsDesk.course.length === 0
          ) {
            return null;
          }

          return (
            <div>
              {record.applicationsDesk.course.map((item, key) => {

                if (
                  !item ||
                  !Array.isArray(item.applicationStatus) ||
                  item.applicationStatus.length === 0
                ) {
                  return null;
                }

                return (
                  <div key={key}>
                    {item.applicationStatus.map((application, index) => {

                      if (
                        application &&
                        application.status === "Processed"
                      ) {
                        return (
                          <div key={index}>
                            {application.processedBy}
                          </div>
                        );
                      }

                      return null;
                    })}
                  </div>
                );
              })}
            </div>
          );
        },
      },
      {
        title: "Branch",
        width: 150,
        key: "studentBranchId",
        filters: allBranches,
        render: (text, record) => {
          return (
            <div>
              {record.studentBranchId ? record.studentBranchId.branchName : ""}
            </div>
          );
        },
      },
      {
        title: "Transfered Date",
        key: "moveDeskDate.moveToApplicationDesk",
        dataIndex: "moveDeskDate.moveToApplicationDesk",
        searchDateName: "moveDeskDate.moveToApplicationDesk",
        width: 100,
        render: (text, record) => {
          return <div>{text ? moment(text).format(dateFormat) : ""}</div>;
        },
      },
      {
        title: "Last Updated By",
        width: 150,
        key: "updatedByUser",
        dataIndex: "updatedByUser",
        searchTextName: "updatedByUser",
        render: (text, record) => {
          return (
            <div>
              <div className={common.user}>{text ? text.name : ""}</div>
              <small>{text ? moment(text.time).format("lll") : ""}</small>
            </div>
          );
        },
      },
    ];
    return (
      <PageHeaderWrapper
        deskColor={deskColor}
        title={` APPLICATION DESK : ${this.state.count} `}
        subTitle={`Follow Up Overdue : ${this.state.followDuesCount}`}
        followUpsCallback={this.followUpsCallback}
      >
        {this.state.showFollowUp ? (
          <ListFollowUps studentObj={studentObj} onClose={this.closeFollowUp} />
        ) : null}
        <Card style={{ marginBottom: 10 }}>
          <div>
            <Col span={6}>
              <label>Date of Lead transfer</label><br></br>
              <RangePicker
                showTime={{ format: "HH:mm" }}
                format="YYYY-MM-DD"
                placeholder={["Start Date", "End Date"]}
                onChange={this.chooseRangerPickerApplicationDesk}
                onOk={this.onOk}
              />
            </Col>
            <Col span={4} style={{ marginTop: 15 }}>
              {
                rightAuth.checkRights("ApplicationDeskExcelExport.view") ?
                  <Button
                    style={{}}
                    onClick={() => this.exportExcel()}>
                    Export Excel
                  </Button>
                  : null
              }

            </Col>
          </div>
        </Card>
        <Card style={{ marginBottom: 10 }}>
          <div>
            <Row>
              {/* <Col span={4}>
                <div>
                  <label>Show By Counsellors</label>
                  <br></br>
                  <Select
                    allowClear
                    style={{
                      width: '90%',
                      marginRight: '10%',
                    }}
                    showSearch={true}
                    className={common.width100Pr}
                    value={this.state.counsellorId}
                    placeholder="Select Option"
                    optionFilterProp="display"
                    onChange={(counsellorId) => {
                      this.setState(
                        {
                          counsellorId: counsellorId && counsellorId.toString(),
                        },
                        () => {
                          setTimeout(() => {
                            this.reload();
                          }, 500);
                        }
                      );
                    }}
                  >
                    {counsellors.map((val, idn) => {
                      return (
                        <Option key={idn} value={val.id}>
                          {val.display}
                        </Option>
                      );
                    })}
                  </Select>
                </div>
              </Col> */}
              {/* <Col span={4}>
                <div>
                  <label>Vision ID</label>
                  <br></br>
                  <Input
                    allowClear
                    style={{
                      width: '90%'


                    }}

                    value={this.state.studentSearchId}
                    hidden={
                      rightAuth.checkRights("searchStudent.view") === true
                        ? false
                        : true
                    }
                    placeholder="Enter Student ID"
                    onChange={(studentSearchId) => {
                      this.setState(
                        {
                          studentSearchId:
                            studentSearchId && studentSearchId.target.value,
                        },
                        () => {
                          setTimeout(() => {
                            this.table.current.reload();
                          }, 500);
                        }
                      );
                    }}
                  />
                </div>
              </Col> */}
              <Col span={6} >
                <label>Offer Expected Date</label>
                <br></br>
                <RangePicker
                  style={{ maxWidth: '90%' }}

                  showTime={{ format: "HH:mm" }}
                  format="YYYY-MM-DD"
                  placeholder={["Start Date", "End Date"]}
                  onChange={this.chooseRangerPicker}
                  onOk={this.onOk}
                />
              </Col>

              <Col span={4} >
                <label>Search By Course</label>
                <br></br>
                <Input style={{ width: '90%' }}
                  value={courseName}
                  onChange={(e) => {
                    this.setState({ courseName: e.target.value }, () => {
                      this.table.current.reload();
                    });

                  }}
                />
              </Col>

              <Col span={4} >
                <label>Search By University</label>
                <br></br>
                <Input style={{ width: '90%' }}
                  value={universityInstitutionName}
                  onChange={(e) => {
                    this.setState(
                      { universityInstitutionName: e.target.value },
                      () => {
                        this.table.current.reload();
                      }
                    );
                  }}
                />
              </Col>
            </Row>
          </div>
        </Card>
        <Card style={{ marginBottom: 10 }}>
          <div className={styles.filterBlock}>
            <div className={styles.myBtnGroup}>
              <div className="antd-pro-containers-student-inquiry-all-styles-myBtnGroup">
                <Button
                  className={styles.btn}
                  type="primary"
                  onClick={() => this.showEmail()}
                >
                  Send E-mail
                </Button>
                <Button
                  type="primary"
                  className={styles.btn}
                  onClick={() => this.showSMS()}
                >
                  Send SMS
                </Button>
                <Button
                  type="primary"
                  className={styles.btn}
                  onClick={() => this.showWhatsAppSms()}
                >
                  Whatsapp
                </Button>
                <Button
                  className={styles.btn}
                  onClick={() => this.selectAllUserFxn()}
                >
                  Select Visible
                </Button>
                <Button
                  className={styles.btn}
                  onClick={() => this.unselectAllUserFxn()}
                >
                  Unselect Visible
                </Button>
              </div>
            </div>
          </div>
        </Card>
        {
          showDroppedLeads || showDropLead ?
            <Card bordered={true} style={{ marginBottom: 10 }}>
              <Row>
                <Col span={4}>
                  <RightsWrapper myRight={"dropLead.view"}>
                    <Popconfirm
                      title="Are you sure to drop this inquiry?"
                      onConfirm={() => {
                        this.dropLeads()
                      }}
                      onCancel={() => {
                      }}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Button
                        className={styles.btn}
                        type="primary">Drop Selected Leads
                      </Button>
                    </Popconfirm>
                  </RightsWrapper>
                </Col>
                <Col span={4}>
                  <RightsWrapper myRight={"showDropLead.view"}>
                    <Button
                      className={styles.btn}
                      type="primary"
                      onClick={() => {
                        this.toggleDroppedLeads()
                      }}
                    >{this.state.showDropped ? "Show All Leads" : 'Show Dropped Leads'}
                    </Button>
                  </RightsWrapper>
                </Col>
              </Row>

            </Card>
            : null
        }
        <Card bordered={true}>
          <Search id="search-student-input" placeholder="Search Student" onSearch={value => this.changeSearchValue(value)} enterButton />
          {this.state.showWhatsAppSms ? (
            <WhatsAPPSMS
              counsellingData={counsellingData}
              onClose={this.closeWhatsSMS}
            />
          ) : null}

          {
            this.state.showCallDrawer ?
              <ClickToCallDrawer record={this.state.recordForCall} type="inquiry" onClose={this.closeCallDrawer} />
              : null
          }

          {this.state.showSMS ? (
            <SMS counsellingData={counsellingData} onClose={this.closeSMS} />
          ) : null}

          {this.state.showEmail ? (
            <EmailDrawer
              counsellingData={counsellingData}
              onClose={this.closeEmail}
            />
          ) : null}
          <TableComp
            columns={columns}
            ref={this.table}
            id={"applicationDesk"}
            showSelector={true}
            apiRequest={this.apiRequest}
            extraProps={{ scroll: { x: 3620 } }}
            pagination={{
              showSizeChanger: true,
              defaultPageSize: 10,
              pageSizeOptions: ["10", "20", "50", "100", "1000"],
            }}
          />
        </Card>
      </PageHeaderWrapper>
    );
  }
}

const mapStateToProps = ({ global, router }) => ({
  categories: global.categories,
  search: router.location.search,
});
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ApplicationDesk);
